<template>
  <div id="yykh_id">
    <div  style="padding:0.5rem 1.5rem 0;height: 18rem;">
        <a-row style="margin: 2rem 0;">
            <a-col :span="11">
            <div style="display:flex;align-items: center;">
                <div style="flex-shrink: 0;text-align: right;width: 24%;" class="bjb_wid">中文名稱：</div>
                <div class="border_cal">{{datalist.name}}</div>
            </div>
            </a-col>
            <a-col :span="2"></a-col>
            <a-col :span="11">
                <div style="display:flex;align-items: center;">
                    <div style="flex-shrink: 0;text-align: right;width: 24%;" class="bjb_wid">電郵地址：</div>
                    <div class="border_cal">{{datalist.email}}</div>
                </div>
            </a-col>
        </a-row>
        <a-row style="margin: 2rem 0;">
            <a-col :span="11">
            <div style="display:flex;align-items: center;">
                <div style="flex-shrink: 0;text-align: right;width: 24%;" class="bjb_wid">稱謂：</div>
                <div class="border_cal">
                    <span v-if="datalist.cal == 0">先生</span>    
                    <span v-if="datalist.cal == 1">小姐</span>    
                    <span v-if="datalist.cal == 3">太太</span>    
                </div>
            </div>
            </a-col>
            <a-col :span="2"></a-col>
            <a-col :span="11">
            <div style="display:flex;align-items: center;">
                <div style="flex-shrink: 0;text-align: right;width: 24%;" class="bjb_wid">聯絡電話：</div>
                <div class="border_cal"><span v-if="datalist.nationcode">+{{datalist.nationcode}} {{datalist.phonenum}}</span></div>
            </div>
            </a-col>
        </a-row>
        <a-row style="margin: 2rem 0;">
            <a-col :span="11">
            <div style="display:flex;align-items: center;">
                <div style="flex-shrink: 0;text-align: right;width: 24%;" class="bjb_wid">預約日期：</div>
                <a-date-picker format="DD/MM/YYYY" id="aaa"  style="width:100%" :disabled-date="disabledDate"   :inputReadOnly='true'  v-model="form.date" @change="yyDate()" :placeholder="'請選擇預約日期'"  />
            </div>
            </a-col>
            <a-col :span="2"></a-col>
            <a-col :span="11">
            <div style="display:flex;align-items: center;">
                <div style="flex-shrink: 0;text-align: right;width: 24%;" class="bjb_wid">預約時間：</div>
                <a-select v-model="form.time"  :placeholder="'請選擇預約時間'" style="width: 100%">
                    <a-select-option value="9:00-10:00">9:00-10:00</a-select-option>
                    <a-select-option value="10:00-11:00">10:00-11:00</a-select-option>
                    <a-select-option value="11:00-12:00">11:00-12:00</a-select-option>
                    <a-select-option value="12:00-13:00" disabled>12:00-13:00</a-select-option>
                    <a-select-option value="13:00-14:00">13:00-14:00</a-select-option>
                    <a-select-option value="14:00-15:00">14:00-15:00</a-select-option>
                    <a-select-option value="15:00-16:00">15:00-16:00</a-select-option>
                    <a-select-option value="16:00-17:00">16:00-17:00</a-select-option>
                    <a-select-option value="17:00-18:00">17:00-18:00</a-select-option>
                </a-select>
            </div>
            </a-col>
        </a-row>
    </div>
    <div style="width: 100%;height: 1px;border-bottom: 1px solid rgb(232, 232, 232);margin-bottom: .4rem;"></div>
    <div class='warp_mess'>
        <button class='btn1' @click="newJbxxYuYueTime" style="background:#f48d28">提交</button>
    </div>
  </div>
</template>

<script>
import App from "@/assets/app.js";
import moment from "moment";
import dayjs from 'dayjs';
export default {
  components: {
  },
  props: ['record','forms'],
  data() {
    return {
        form:{
            time:'',
            date:'',
        },
        holidaylist:[],
        datalist:'',
    };
  },
  mounted() {
   this.getNewJbxx()
   this.getHolidayList()
  },

  methods: {
    getNewJbxx(file){
      this.$ajax({
        method: "post",
        url: this.$api.getNewJbxx,
        data: {
            "khid": this.record.pdfcode
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
            this.datalist = res.data.result
            this.form.date = res.data.result.date
            this.form.time = res.data.result.time
            console.log(this.datalist);
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    newJbxxYuYueTime(file){
      this.$ajax({
        method: "post",
        url: this.$api.newJbxxYuYueTime,
        data: {
            date:this.form.date,
            time:this.form.time,
            khid: this.record.pdfcode
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
            this.$emit('child', 0)
            App.oTool.successT('操作成功');
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    yyDate(){
        if (this.form.date) {
          this.form.date = this.yyTime3(this.form.date._d)
        }
        console.log(this.form.date);
    },
    yyTime3(today) {
        if(!today){return ''}
        var month = today.getMonth() + 1;
        month = month < 10 ? '0'+month : month;
        var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
        return today.getFullYear() + '-' + month + '-' + day;
    },
    disabledDate(current ){
        const monthEnd = moment().endOf('month')
        // const monthStart = moment().startOf('month')
        const monthOfday = parseInt(moment().format('D'))
        const days = moment(current).format('YYYY-MM-DD');
        return current && current < dayjs().endOf('day') || moment(current).format('d') == 6||moment(current).format('d') == 0||this.holidaylist.includes(days)||current > monthEnd.add('days', 60 + monthOfday);
    },
    getHolidayList(){
        this.$ajax({
          method:'post',
          url:this.$api.getHolidayList,
          data:{}
        }).then(res=>{
          if(res.data.qmiscode === 1000){
            this.holidaylist = res.data.holidaylist
          }
        })
    },


 



  },
};
</script>

<style>
    #yykh_id .ant-col{
        font-size: 0.85rem !important;
    }
  .border_cal{
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    width: 100%;
    height: 1.75rem;
    font-size: 0.8rem;
    padding: 4px 11px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }
    .warp_mess{
        text-align: right !important;
        margin-bottom: .3rem;
        padding: .5rem 0;
    }
    @media only screen and (max-width: 1024px) {
      .ant-select-auto-complete.ant-select .ant-input, .ant-input, .ant-select-selection--single{
        height: 30px;
      }
    }
</style>
<style scoped> 
  @media only screen and (max-width: 1024px) {
    .bjb_wid{
      width: 31% !important;
    }
    .border_cal{
      height: 30px;
    }
   
  }
</style>